import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Meta from "vue-meta";
import "croppie/croppie.css"; // import the croppie css manually
import VueTheMask from "vue-the-mask";
import wysiwyg from "vue-wysiwyg";
// import VueMultiselect from 'vue-multiselect';
import config from "@/config";
import Formatter from "./components/libraries/Formatter";
import authRepository from "./repositories/auth";

const formatter = new Formatter();

Vue.use(VueTheMask);
Vue.use(wysiwyg, {
    hideModules: {
        "link": true,
        "headings": true,
        "code": true,
        "image": true,
        "table": true
    }
});

// FONT AWESOME
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

//========= AXIOS
Vue.prototype.$http = axios;

Vue.prototype.$http.defaults.baseURL = config.api_url;
// Перехватываем протухший token
Vue.prototype.$http.interceptors.response.use(undefined, error => {
  let res = error.response;

  if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
    return new Promise((resolve, reject) => {
      let userData = JSON.parse(localStorage.getItem("userData"));
      const refreshData = {
          refresh_token: userData[0].refresh_token,
          token: userData[0].token
      };

      authRepository.refreshSecure(refreshData).then(resp => {
          const tokenT = resp.data.token;
          const refresh_token = resp.data.refresh_token;
          const perms = resp.data.permissions;
          let userData = [{}];
          let getThisData = JSON.parse(localStorage.getItem("userData"));
          userData[0].token = tokenT;
          userData[0].refresh_token = refresh_token;
          userData[0].email = getThisData[0].email;
          localStorage.setItem("userData", JSON.stringify(userData));
          localStorage.setItem("permissions", JSON.stringify(perms));
          Vue.prototype.$http.defaults.headers.common[
              "Authorization"
              ] = `Bearer ${tokenT}`;
          error.config.headers.Authorization = `Bearer ${tokenT}`;
          error.config.__isRetryRequest = true;
          resolve(axios(error.config));
      }).catch(err => {
          store.dispatch("logout").then(() => {
              router.push("/");
          });
          reject(err);
      });
    });
  }else if(res.status === 499){
      router.push("/service-work");
  }
  return Promise.reject(error);
});

const userDataStorage = JSON.parse(localStorage.getItem("userData"));
let token = false;
if (userDataStorage) {
  token = userDataStorage[0].token;
}

const browserIdStorage = localStorage.getItem('enroller_browser_id');
let enrollerBrowserId = false;
if (browserIdStorage) {
  enrollerBrowserId = browserIdStorage;
}else{
  let newBrowserId = formatter.generateHash(20);
  localStorage.setItem("enroller_browser_id", newBrowserId);
  enrollerBrowserId = newBrowserId;
}

// EnrollerBrowserId все равно используется вместе с токеном, поэтому всунем в один блок
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  Vue.prototype.$http.defaults.headers.common["EnrollerBrowserId"] = enrollerBrowserId;
}
//========= END AXIOS


library.add(fas);
Vue.component("f-awesome", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(Meta);

new Vue({
    router,
    store,
  render: h => h(App)
}).$mount("#app");
